var React = require('react');

function Athanor (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Athanor"),React.createElement("g",{"id":"g1491","key":2},[React.createElement("path",{"id":"path1828-2","className":"cls-1","d":"M84,83.92h20v-40H24v40H44","key":0}),React.createElement("path",{"id":"path1830-0","className":"cls-1","d":"M64,63.92v30","key":1})])]);
}

Athanor.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Athanor;

Athanor.default = Athanor;
